import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import getters from './getters';
import mutations from './mutations';


Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'  //生产环境

export default new Vuex.Store({
  state,
  getters,
  mutations
})
